import { render, staticRenderFns } from "./ColorModuleSearch.vue?vue&type=template&id=7bc1b64d&scoped=true"
import script from "./ColorModuleSearch.vue?vue&type=script&lang=ts"
export * from "./ColorModuleSearch.vue?vue&type=script&lang=ts"
import style0 from "./ColorModuleSearch.vue?vue&type=style&index=0&id=7bc1b64d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc1b64d",
  null
  
)

export default component.exports